import React from 'react';

import RegistrationWrapper from 'common/canny/register/RegistrationWrapper';
import AdminOnboardingFieldLabel from 'common/subdomain/admin/AdminOnboarding/AdminOnboardingFieldLabel';
import AdminOnboardingMultiSelect from 'common/subdomain/admin/AdminOnboarding/AdminOnboardingMultiSelect';
import { CollectFeedbackOptionValue } from 'common/subdomain/admin/AdminOnboarding/constants';
import { howOptions } from 'common/subdomain/admin/AdminOnboarding/data';
import VStack from 'common/uiV3/VStack';

import type { RegistrationStepProps } from 'common/subdomain/admin/AdminOnboarding/Types';

const AdminOnboardingHow = ({ onChange, onboarding }: RegistrationStepProps) => {
  const onChangeSelect = (motivations: string[]) => {
    const wantsPrivate =
      motivations.includes(CollectFeedbackOptionValue.Autopilot) ||
      motivations.includes(CollectFeedbackOptionValue.Behalf);
    onChange({
      motivations,
      private: wantsPrivate,
    });
  };

  const { motivations } = onboarding;
  return (
    <RegistrationWrapper.Content className="gap-6">
      <RegistrationWrapper.Header>
        <RegistrationWrapper.Title>How do you want to collect feedback?</RegistrationWrapper.Title>
      </RegistrationWrapper.Header>
      <VStack className="gap-2">
        <AdminOnboardingFieldLabel isRequired>Select all that apply</AdminOnboardingFieldLabel>
        <AdminOnboardingMultiSelect
          optionType="card"
          onChange={onChangeSelect}
          options={howOptions}
          selected={motivations}
        />
      </VStack>
    </RegistrationWrapper.Content>
  );
};

export default AdminOnboardingHow;
